var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVolumeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17.75c-2.42 0-3.75-1.33-3.75-3.75v-4c0-2.42 1.33-3.75 3.75-3.75h1.43c.23 0 .46-.07.66-.19l2.92-1.83c1.46-.91 2.88-1.08 4-.46 1.12.62 1.73 1.91 1.73 3.64v.96c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-.96c0-1.14-.35-1.99-.96-2.32-.61-.34-1.51-.19-2.48.42L7.88 7.33c-.43.28-.94.42-1.45.42H5c-1.58 0-2.25.67-2.25 2.25v4c0 1.58.67 2.25 2.25 2.25h2c.41 0 .75.34.75.75s-.34.75-.75.75H5zM10.02 19.76a.747.747 0 1 1 .79-1.27c.97.6 1.87.76 2.48.42.61-.34.96-1.19.96-2.32v-3.64c0-.41.34-.75.75-.75s.75.34.75.75v3.64c0 1.72-.62 3.02-1.73 3.64-.45.24-.95.36-1.47.36-.79 0-1.66-.28-2.53-.83zM17.55 16.6a.75.75 0 0 1-.15-1.05 5.926 5.926 0 0 0 .72-5.84.75.75 0 0 1 .4-.98c.38-.16.82.02.98.4 1.02 2.42.67 5.23-.9 7.33a.758.758 0 0 1-1.05.14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.38 19.1a.75.75 0 0 1-.15-1.05c2.14-2.85 2.61-6.67 1.23-9.96a.75.75 0 0 1 .4-.98c.39-.16.82.02.98.4 1.59 3.78 1.05 8.16-1.41 11.44-.14.2-.37.3-.6.3a.76.76 0 0 1-.45-.15zM1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVolumeSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-volume-slash.bdbe4681d85ceece724f5f385c2d4771.svg";
export { ForwardRef as ReactComponent };